import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b4c44c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Memphis Foundation")
], -1))
const _hoisted_2 = { class: "d-flex flex-column align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" The official website of the ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Memphis Foundation.")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center fw-bold" }, "OUR MISSION", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center col-6" }, " At the Memphis Foundation we work to empower deaf and blind young people and to strengthen communities that support these young people through the power of sports and music. ", -1))

import PageFooter from '@/components/PageFooter.vue';
import BackButton from '@/components/buttons/BackButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CharityPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(BackButton),
      _hoisted_1,
      _createElementVNode("main", null, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("img", {
            class: "my-3 banner-image img-thumbnail",
            src: require('@/assets/charity.png'),
            alt: "placeholder"
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_b_link, {
              href: "https://memphisfoundation.org",
              target: "_blank",
              rel: "noreferrer noopener"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})